import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

const API_URL = process.env.REACT_APP_API_URL;

export function usePageView() {
  const location    = useLocation();
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  const lastPath    = useRef('');

  useEffect(() => {
    if (!isAuthenticated) return;
    // Dedupe — don't log the same path twice in a row
    const path = location.pathname;
    if (path === lastPath.current) return;
    lastPath.current = path;

    getAccessTokenSilently({
      authorizationParams: { audience: process.env.REACT_APP_AUTH0_AUDIENCE },
    }).then(token =>
      fetch(`${API_URL}api/pageviews`, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body:    JSON.stringify({ path }),
      })
    ).catch(() => {}); // silent fail — never affect the user
  }, [location.pathname, isAuthenticated]);
}